import FleetList from '@src/pages/Fleet/List';
import { createFileRoute } from '@tanstack/react-router';

import { getLocalizedTitle } from '../title';

export type FleetRouteSearch = {
  q?: string;
  ordering?: string;
  expanded?: string;
  branch?: string;
  vehicle_type?: string;
  vehicle_q?: string;
  type_q?: string;
  year_from?: string;
  year_to?: string;
  capacity_from?: string;
  capacity_to?: string;
  distance_from?: string;
  distance_to?: string;
  cost_from?: string;
  cost_to?: string;
  status?: string;
};

function optionalString(value: unknown): string | undefined {
  return typeof value === 'string' && value.length > 0 ? value : undefined;
}

export const Route = createFileRoute('/_app/fleet/')({
  validateSearch: (search): FleetRouteSearch => ({
    q: optionalString(search.q),
    ordering: optionalString(search.ordering),
    expanded: optionalString(search.expanded),
    branch: optionalString(search.branch),
    vehicle_type: optionalString(search.vehicle_type),
    vehicle_q: optionalString(search.vehicle_q),
    type_q: optionalString(search.type_q),
    year_from: optionalString(search.year_from),
    year_to: optionalString(search.year_to),
    capacity_from: optionalString(search.capacity_from),
    capacity_to: optionalString(search.capacity_to),
    distance_from: optionalString(search.distance_from),
    distance_to: optionalString(search.distance_to),
    cost_from: optionalString(search.cost_from),
    cost_to: optionalString(search.cost_to),
    status: optionalString(search.status),
  }),
  head: () => ({
    meta: [{ title: getLocalizedTitle('fleet.page_title', 'Fleet') }],
  }),
  component: FleetRoute,
});

function FleetRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <FleetList
      search={search}
      onSearchChange={(update, replace = true) =>
        void navigate({
          search: (current) => ({ ...current, ...update }),
          replace,
        })
      }
    />
  );
}
